/* eslint-disable react/jsx-key */
import React, { useContext, useState } from 'react'
import { strCol, dateCol } from '@integec/grid-tools/lib/cols'
// eslint-disable-next-line no-unused-vars
import moment from 'moment'
import { getApiTargetInfo, UtilityUnitSelection } from 'core'
import { connect } from 'react-redux'
import {
  marginPnodeZone,
  marginPnodeZoneUpdate,
  marginPnodeZoneDelete,
} from 'api/pgads.js'
import {
  getEventTypes,
  getUtilityNameMap,
  getUnitNameMap,
} from 'core/selectors'

import { Button, Input, DatePicker } from 'antd'
import styled from 'styled-components'
import CommonScreen from 'admin/component/CommonScreen'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import { PNodeZoneContext } from 'context'

const TableTD = styled.td`
  text-align: end;
  max-width: 100px;
  width: 100px;
`

const retrieveTask = apiTargetInfo => marginPnodeZone(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  marginPnodeZoneUpdate(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  marginPnodeZoneDelete(apiTargetInfo)(data)

const title = 'PNode Zone'

// eslint-disable-next-line no-unused-vars
const MarginPnodeZone = ({ utilityNameMap, unitNameMap, ...props }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const { loadPNodeZone } = useContext(PNodeZoneContext)

  const headerWithFormatter = OaMaPnodeZoneHeaders.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unitId'
      ? {
          ...header,
          // choices: [],
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : header
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Unit :</TableTD>
            <td colSpan={3} style={{}}>
              <UtilityUnitSelection
                casStyle={{ width: '100%' }}
                utility={insertData.utility}
                unit={insertData.unit}
                onUnitChange={value => {
                  // setUtilityUnit(value)
                  setInsertData({
                    ...insertData,
                    utility: value[0],
                    unit: value[1].substr(value[0].length),
                    unitId: value[1],
                  })
                }}
              />
            </td>
            <TableTD> Effective Date :</TableTD>
            <td colSpan={1}>
              <DatePicker
                style={{ width: '100%' }}
                allowClear
                format="MM/DD/YYYY"
                value={insertData.effectiveDateMoment}
                onChange={d => {
                  setInsertData({
                    ...insertData,
                    effectiveDateMoment: d,
                    effectivedate: d.format('YYYY-MM-DD'),
                  })
                }}
              />
            </td>
          </tr>
          <tr>
            <TableTD>Pnode Id :</TableTD>
            <Input
              value={insertData.pnodeid}
              onChange={e =>
                setInsertData({ ...insertData, pnodeid: e.target.value })
              }
            />
            <TableTD>EMKT Id :</TableTD>
            <Input
              value={insertData.emktid}
              onChange={e =>
                setInsertData({ ...insertData, emktid: e.target.value })
              }
            />
            <TableTD>Rollup Emkt Id :</TableTD>
            <Input
              value={insertData.rollupEmktid}
              onChange={e =>
                setInsertData({ ...insertData, rollupEmktid: e.target.value })
              }
            />
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
              <Button
                type="primary"
                onClick={() => onAdd(false)}
                style={{ marginLeft: '20px' }}
              >
                Add & Hide
              </Button>
              <Button
                type="danger"
                onClick={onCancel}
                style={{ marginLeft: '20px' }}
              >
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const onRetrieveData = _ => loadPNodeZone()

  return [
    <CommonScreen
      isAdminScreen={false}
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.utility}
      autoRetrieve
      // sortOptions={headerWithFormatter}
      sortOptions={[utilityHeader, unitIdHeader]}
      initialSortOptions={[utilityHeader, unitIdHeader]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      // widthOffset={550}
      // heightOffset={100}
      onRetrieveData={onRetrieveData}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  eventTypes: getEventTypes(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  // utilityUnitMap: getUtilityUnitsMap(state),
  // units: getUnits(state),
})

export default connect(mapStateToProps)(MarginPnodeZone)

const OaMaPnodeZoneHeaders = [
  // strCol({ ident: 'utility', display: 'Utility', isKey: true }),
  // strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  utilityHeader,
  unitIdHeader,
  dateCol({
    ident: 'effectivedate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'pnodeid',
    display: 'PNode Id',
    isFiltered: true,
    width: 200,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'emktid',
    display: 'Emkt Id',
    isFiltered: true,
    width: 200,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'rollupEmktid',
    display: 'Rollup Emkt Id',
    isFiltered: true,
    width: 200,
    // sortOrder: 'asc',
  }),
  modifierCol,
  modifiedDateCol,
]
